import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { FormComponent } from "DMS/Interfaces/form.component";

@Component({
	selector: 'dms-print',
	templateUrl: './print.component.html'
})
export class PrintComponent extends FormComponent implements OnInit {
}